import { useEffect, useState } from 'react';
import { globalHistory } from '@gatsbyjs/reach-router';

/**
 * Safe pathname reader that does not depend on LocationContext.Provider.
 * Works when rendered from wrapRootElement and during SSR.
 */
export function usePathname(): string {
  const [pathname, setPathname] = useState(() => {
    if (typeof window === 'undefined') return '/';
    return window.location.pathname;
  });

  useEffect(() => {
    return globalHistory.listen(({ location }) => {
      setPathname(location.pathname);
    });
  }, []);

  return pathname;
}

